"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSidebarNavigation = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Link_1 = require("../Link");
require("./index.scss");
const className = 'page-sidebar-navigation';
class PageSidebarNavigation extends react_1.default.PureComponent {
    render() {
        const { isDisabled, isRouteMatch, modificators, routeItems } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, [
            modificators,
            isDisabled ? 'disabled' : undefined,
        ]);
        const routes = routeItems ? routeItems.map((route) => (react_1.default.createElement(Link_1.PageSidebarLink, { key: `PageSidebarLink:${route.routeKey}`, navigationClassName: className, isRouteMatch: isRouteMatch, ...route }))) : null;
        return (react_1.default.createElement("div", { className: classNames }, routes));
    }
}
exports.PageSidebarNavigation = PageSidebarNavigation;
PageSidebarNavigation.defaultProps = {
    isDisabled: false,
    isRouteMatch: () => false,
};
//# sourceMappingURL=index.js.map